// src/slices/writer/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Get all writers
 */
export const getAllWriters = createAsyncThunk("writer/getAll", async (_, { rejectWithValue }) => {
  try {
    const res = await axios.get(`${API_URL}/writer/all`);
    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});

/**
 * Get one writer by slug or id
 */
export const getOneWriter = createAsyncThunk("writer/getOne", async (identifier, { rejectWithValue }) => {
  try {
    const res = await axios.get(`${API_URL}/writer/one`, { params: { identifier } });


    return res.data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});
